import {
  useEffect,
  useRef
} from 'react'
import {
  Marker,
  useMap
} from 'react-leaflet'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import dayjs from 'dayjs'
import {
  authSelectors,
  chatCredentialsSelectors,
  markersSelectors,
  setIsSignIn,
  setPosts,
  setProfileItemId,
  setSelectedMarkerData,
  setUserSectionPage,
  usersSelectors,
  handleOpenModal,
  setChatSectionPage,
  setOpenPopupBlogs,
  setOpenPopupEvents,
  setNotificationSectionPage,
  setBlogRepostData,
  deleteProfileItem,
  setSelectedEventData
} from 'store'
import {
  LOCATION_TYPE,
  MAX_ZOOM_LEVEL,
  MODAL_SECTION,
  UNSUPPORTED_MAX_ZOOM_LEVEL
} from 'utils/constants'
import { createMarkerColor } from 'utils/helpers'
import { v4 as uuid } from 'uuid'
import { ImagesPng } from 'assets/images'

export const MarkerItem = ({
  item,
  geoLoc,
  profileAvatar,
  isAuth
}) => {
  const {
    activeProfile,
    profileItemId
  } = useSelector(usersSelectors)
  const { isSignIn } = useSelector(authSelectors)
  const { xmppLiveLocation } = useSelector(chatCredentialsSelectors)
  const {
    selectedEventData,
    selectedMarkerData
  } = useSelector(markersSelectors)
  const mouseDownOnMarkerRef = useRef(false)
  const markerRef = useRef(null)
  const map = useMap()
  const [searchParams, setSearchParams] = useSearchParams()
  const dispatch = useDispatch()
  const liveLocCoord = [xmppLiveLocation?.lat, xmppLiveLocation?.lng]

  const iconMarker = createMarkerColor(
    dayjs(item?.last_accessed),
    profileAvatar ?? ImagesPng.DefaultImage,
    item?.is_friends,
    isAuth
  )
  const id = item?.id
  const idParam = searchParams.get('id')

  /* eslint-disable no-underscore-dangle */
  const markerPostForPopup = () => {
    if (item.coordinates[0] >= 84.8) {
      map.setView(markerRef?.current?._latlng, UNSUPPORTED_MAX_ZOOM_LEVEL)

      return 500
    }

    if (item.coordinates[0] >= 84.6) {
      map.setView(markerRef?.current?._latlng, 21)

      return 500
    }

    if (item.coordinates[0] >= 83.6) {
      map.setView(markerRef?.current?._latlng, 19)

      return 500
    }

    if (item.coordinates[0] >= 60) {
      map.setView(markerRef?.current?._latlng, 7)

      return 500
    }

    return 0
  }
  /* eslint-disable no-underscore-dangle */

  const handleSelectedMarkerData = () => {
    setTimeout(() => {
      dispatch(setProfileItemId(item.id))
      dispatch(setSelectedMarkerData(item))
    }, markerPostForPopup())
  }

  const handleClick = () => {
    if (isAuth) {
      document.querySelector('#custom-popup-overlay')?.click()
      document.querySelector('#custom-popup-overlay-event')?.click()
      dispatch(setChatSectionPage('clear'))
      dispatch(setUserSectionPage('clear'))
      dispatch(setOpenPopupBlogs(false))
      dispatch(setOpenPopupEvents(false))
      dispatch(setNotificationSectionPage('clear'))
      dispatch(setBlogRepostData([]))
      dispatch(handleOpenModal({
        isOpen: false,
        section: MODAL_SECTION.RightSection
      }))

      setTimeout(() => {
        dispatch(setPosts([]))
        dispatch(deleteProfileItem())
        dispatch(setProfileItemId(null))
        dispatch(setSelectedMarkerData(null))
        dispatch(setSelectedEventData(null))
        setSearchParams({ id })

        handleSelectedMarkerData()
      }, selectedEventData || profileItemId ? 1200 : 0)
    }
  }

  setTimeout(() => {
    if (
      +idParam === id
      && markerRef.current
      && +sessionStorage.getItem('id') === id
      && (
        profileItemId !== item.id
        || selectedMarkerData?.id !== item.id
      )
    ) {
      handleSelectedMarkerData()
    }
  }, 500)

  useEffect(() => {
    const marker = markerRef.current

    if (
      +idParam !== id
      && +sessionStorage.getItem('id') === id
      && markerRef.current
      && (
        localStorage.getItem('isNotifOpen') === null
        || localStorage.getItem('isNotifOpen') === 'false'
      )
    ) {
      dispatch(setUserSectionPage('clear'))
      setSearchParams({ id })
    } else if (
      isSignIn
      && activeProfile?.id === id
      && +idParam !== id
      && sessionStorage.getItem('id') === null
      && marker
      && sessionStorage.getItem('eventid') === null
    ) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(marker._latlng, MAX_ZOOM_LEVEL ?? 16)
      dispatch(setIsSignIn(false))
    }
  }, [])

  // Multiple mouse and touch events are used instead of only "click"
  // as a workaround for clicking markers that are outside of the bounds
  return (
    <Marker
      zIndexOffset={-99999}
      eventHandlers={{
        click: () => {
          if (item?.coordinates[0] < 84.5) {
            handleClick()
          }
        },
        mousedown: () => {
          mouseDownOnMarkerRef.current = true
        },
        mouseup: () => {
          if (mouseDownOnMarkerRef.current && item?.coordinates[0] >= 84.5) {
            handleClick()
          }

          mouseDownOnMarkerRef.current = false
        },
        mouseout: () => {
          mouseDownOnMarkerRef.current = false
        },
        touchStart: () => {
          mouseDownOnMarkerRef.current = true
        },
        touchEnd: () => {
          if (mouseDownOnMarkerRef.current && item?.coordinates[0] >= 84.5) {
            handleClick()
          }

          mouseDownOnMarkerRef.current = false
        },
        touchCancel: () => {
          mouseDownOnMarkerRef.current = false
        }
      }}
      key={uuid()}
      position={
        geoLoc
        && Number.isNaN(xmppLiveLocation.lat) === false
        && item.location_type[LOCATION_TYPE.LiveLocation] === 0
          ? liveLocCoord
          : item?.coordinates
      }
      icon={iconMarker}
      ref={markerRef}
      {...(isAuth ? { title: item?.id } : {})}
    />
  )
}
